import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["outlineWidth", "className", "style", "children"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { createElement } from 'react';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
var Svg = function Svg(_ref) {
  var outlineWidth = _ref.outlineWidth,
    className = _ref.className,
    style = _ref.style,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var svgSize = 32;
  var offset = 0;
  if (outlineWidth) {
    svgSize += outlineWidth;
    offset = outlineWidth / 2;
  }
  return /*#__PURE__*/_jsx("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: svgSize + 'px',
    height: svgSize + 'px',
    viewBox: "0 0 ".concat(svgSize, " ").concat(svgSize),
    xmlSpace: "preserve",
    className: "ptr-map-shape ".concat(className || ''),
    style: style,
    children: /*#__PURE__*/createElement(children, _objectSpread(_objectSpread({}, rest), {}, {
      offset: offset,
      outlineWidth: outlineWidth,
      className: className,
      style: style
    }))
  });
};
Svg.propTypes = {
  children: PropTypes.elementType,
  className: PropTypes.string,
  outlineWidth: PropTypes.number,
  style: PropTypes.object
};
export default Svg;